// *.miotech.com
const devKey = '0x4AAAAAAA35whcVsDoYLsYi';

// *.pacifictradeinvest.org.cn
const prodKey = '0x4AAAAAAA4SddJGsfymvXBI';
const getSiteKey = () => {
  if (window.location.host.includes('miotech')) {
    return devKey;
  }
  return prodKey;
};

export const sitekey = getSiteKey();
